import React, {FC, useCallback, useState} from 'react'
import {useDropzone} from 'react-dropzone'

import { FiUpload } from 'react-icons/fi';

import './styles.css';

interface Iprops {
  selectePropUpload: (file: File) => void
}

const MyDropzone: FC<Iprops> = ({ selectePropUpload }) => {
  const [selectFileUrl, setSelectFileUrl] = useState('');

  const onDrop = useCallback(acceptedFiles => {
    const file = acceptedFiles[0];

    const url = URL.createObjectURL(file);
 
    setSelectFileUrl(url);
    selectePropUpload(file);
  }, [selectePropUpload]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/*'
  });

  return (
    <div className="dropzone" { ...getRootProps() }>
      <input { ...getInputProps() } accept='image/*' />

      {
        selectFileUrl ?
        <img src={ selectFileUrl } alt="imageUpload" /> :
        <p>
          <FiUpload />
          Imagem do estabelecimento
        </p>
      }
    </div>
  )
}

export default MyDropzone;